import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { tableHelper } from '@builttocreate/engine-utils';

import ImageManager from '../../../misc/ImageManager';
import FieldTypes from '../../../../constants/FieldTypes';

const { getRowOrder } = tableHelper;

const StyledWrapper = styled.div`
  width: 100%;

  /*
   * Only use height when you don't need height 
   * measurements of the table field.
   */
  ${(props) => {
    return props.measure ? '' : 'height: 100%;';
  }}

  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  border: ${(props) => props.border};
  ${(props) => (typeof props.margin === 'number' ? `padding: ${props.margin}px;` : '')}
`;

const TableImageField = ({
  fieldId,
  fieldIdentifier,
  fieldPositionId,

  columnType,
  column,
  rowId,
  rowIndex,
  rowOrder,
  columnIdentifier,

  tableColumns,

  onCellUpload,
  onCellChange,
  onFocus,

  value,
  cellValue,
  disabled,

  fontColor,
  primaryColor,
  dangerColor,
  backgroundColor,
  borderRadius,
  borderWidth,
  borderColor,
  margin,
  padding,

  //Used for calculating width and height of element
  measure,
  onMeasureCompleted

}) => {

  const [wrapperRef, setWrapperRef] = useState(null);
  const [loadedImages, setLoadedImages] = useState(false);

  const columnObject = tableColumns.find((col) => col._id === column);

  useEffect(() => {
    if (onMeasureCompleted && wrapperRef && loadedImages) {
      onMeasureCompleted(fieldId, fieldIdentifier, fieldPositionId, wrapperRef.getBoundingClientRect());
    }
  }, [wrapperRef, loadedImages]);

  const handleLoadCompleted = () => {
    setLoadedImages(true);
  };

  const handleDrop = (files) => {
    if (onCellUpload && rowId) onCellUpload(fieldId, fieldIdentifier, fieldPositionId, rowId, column, files);
  };

  const handleDelete = (i) => {

    const nextImageValues = [...cellValue];
    nextImageValues.splice(i, 1);

    onCellChange(fieldId, fieldIdentifier, fieldPositionId, rowId, column, nextImageValues);

  };

  const handleFocus = () => {

    if (onFocus && Object.keys(columnObject).length > 0) {

      onFocus(fieldId, fieldIdentifier, fieldPositionId, {}, rowId, column, columnIdentifier, {}, columnType);

    }

  };

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  const isRowDeleted = !getRowOrder(rowOrder, value)[rowIndex];

  return (
    <StyledWrapper
      data-testid={`${fieldPositionId}-table-image-field`}
      {...{
        backgroundColor,
        border,
        borderRadius,
        margin,
        measure
      }}
      ref={(e) => {
        if (e && !wrapperRef) setWrapperRef(e);
      }}
    >
      <ImageManager
        {...{
          type: FieldTypes.image, // type is need to only allow images for image field
          value: cellValue,
          multiple: true,
          disabled: disabled || isRowDeleted,

          primaryColor,
          dangerColor,
          fontColor,
          borderColor,
          borderWidth,
          borderRadius,
          backgroundColor,
          padding, //Default spacing around images
          maxWidth: columnObject?.maxImageWidth ? `${columnObject.maxImageWidth}px` : 0,
          maxHeight: columnObject?.maxImageHeight ? `${columnObject.maxImageHeight}px` : 0,

          onDelete: handleDelete,
          onFocus: handleFocus,
          onDrop: handleDrop,
          onLoadCompleted: handleLoadCompleted,
        }}
      />
    </StyledWrapper>
  );

};

export default React.memo(TableImageField);
